module.exports = __webpack_public_path__ + "static/media/konpers_parawajah.22d4b790.jpeg";